import { FaApple } from "react-icons/fa";
import React from "react";
import "./AppleButton.scss";

interface Props {
  loading?: boolean;
  signInWithApple: Function;
  cssClass?: string;
}

const AppleButton: React.FC<Props> = ({
  loading,
  signInWithApple,
  cssClass = "",
}) => (
  <>
    <button
      type="button"
      className={`AppleButton w-100 ${cssClass}`}
      onClick={() => signInWithApple()}
      disabled={loading}
      style={{marginTop: "0"}}
    >
      <FaApple size="18px" style={{ verticalAlign: "text-top" }} />
      &nbsp; Apple
    </button>
  </>
);

export default AppleButton;
